import React, { Component } from "react";
import Header from "@/bit/components/components.header";
import Footer from "@/bit/components/components.footer";
import MetaData from "@/bit/core/core.meta-data";
import Text, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from "@/bit/components/components.text";
import { wrapper } from "store";
import { END } from "redux-saga";

class E500 extends Component {
  logError = (error) => {
    import("@gcloud-npm/utils.monitoring.front-sonda").then(
      (frontSondaModule) => {
        const sonda = new frontSondaModule.default({
          kind: "FATAL",
          processName: "ErrorBoundary",
          filePath: "error500",
        });
        console.log(error);
        sonda.errorMessage({ error, info: "Ha caido en el errorBoundary" });
      }
    );
  };

  componentDidMount() {
    try {
      const { error } = this.props;
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href =
        "https://prod.cms.col.movistar.es/static/ts/next13/beach.style.min.css";
      document.head.appendChild(link);
      this.logError(error);
    } catch (err) {
      // console.error(err)
    }
  }
  render() {
    const { breadcrumbsProps, headerProps, seoInfo, error, footerProps } =
      this.props;

    return (
      <>
        <MetaData seoInfo={seoInfo} />
        <Header {...breadcrumbsProps} {...headerProps} />
        <main className="beach" style={{ height: "80vh" }}>
          <div className="messageContainer">
            <Text
              size={TEXT_SIZE.DISPLAY2}
              fontType={TEXT_FONT_WEIGHT.LIGHT}
              color={TEXT_COLOR.WHITE}
              align={TEXT_ALIGN.CENTER}
              text="500"
              cyData="500"
            />
            <Text
              size={TEXT_SIZE.TITLE45}
              fontType={TEXT_FONT_WEIGHT.LIGHT}
              color={TEXT_COLOR.WHITE}
              align={TEXT_ALIGN.CENTER}
              text="Lo sentimos, ha ocurrido un error"
            />
          </div>
          <div className="cloud x1" />
          <div className="cloud x1_5" />
          <div className="cloud x2" />
          <div className="cloud x3" />
          <div className="cloud x4" />
          <div className="cloud x5" />
        </main>
        <Footer footerProps={footerProps} />
      </>
    );
  }
}

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const modules = await Promise.all([
    await import("@gcloud-npm/adabyron.misc.get-static-content"),
    await import("@gcloud-npm/normalizers.components-header.sections"),
    await import("@gcloud-npm/normalizers.components-header.breadcrumbs"),
    await import("@/bit/reducers/reducers.header-reducer"),
    await import("@gcloud-npm/adabyron.custo.get-seo"),
    await import("@gcloud-npm/adabyron.custo.get-by-name"),
  ]);
  const getStaticContent = modules[0].default;
  const getHeaderSections = modules[1].default;
  const getBreadcrumbs = modules[2].default;
  const headerActions = modules[3].actions;
  const getSeo = modules[4].default;
  const getByName = modules[5].default;

  const context = store.getState().main.context;

  // HEADER
  // HEADER USUAL PROPS
  const breadcrumbsInfoJson = await getByName({
    name: "HEADER-INFO",
    kind: "activity",
    context,
    build: true,
  });
  const url = "";
  const breadcrumbsProps = getBreadcrumbs(breadcrumbsInfoJson, url);
  const headerInfoJson = await getByName({
    name: "HEADER-BURGUER-MENU-1",
    kind: "creativity",
    context,
    build: true,
  });
  const seoInfo = await getSeo({ context, location: "www.movistar.es/500" });
  // HEADER REDUX PROPS
  const headerProps = getHeaderSections(headerInfoJson, breadcrumbsProps);
  store.dispatch(headerActions.setupHeaderProps(headerProps));

  // FOOTER USUAL PROPS
  const footerProps = await getByName({
    name: "FOOTER-INFO",
    kind: "activity",
    context,
    build: true,
  });
  store.dispatch(END);
  await store.sagaTask.toPromise();
  return {
    props: {
      seoInfo,
      headerProps,
      breadcrumbsProps,
      footerProps,
    },
  };
});

export default E500;
